import { RichText } from '../i18n/RichText';
import { t } from '../services/language-manager';

interface SetupPageProps {
  orgName: string;
  dataRegion: string;
  onDataRegionChange: (region: string) => void;
  onNext: () => void;
  onBack: () => void;
}

export function SetupPage({
  orgName,
  dataRegion,
  onDataRegionChange,
  onNext,
  onBack,
}: SetupPageProps) {
  return (
    <div className="card">
      <div className="card__title">{t('setup-title')}</div>
      <div className="card__subtitle">{t('setup-subtitle')}</div>

      <div className="form-group">
        <label className="form-label">{t('setup-org-name')}</label>
        <input
          type="text"
          className="form-input"
          value={orgName}
          readOnly
        />
      </div>

      <div className="form-group">
        <label className="form-label">{t('setup-data-region')}</label>
        <select
          className="form-select"
          value={dataRegion}
          onChange={(e) => onDataRegionChange(e.target.value)}
        >
          <option value="US">{t('setup-region-us')}</option>
          <option value="EU">{t('setup-region-eu')}</option>
        </select>
        <div className="form-hint">
          <RichText
            k="setup-data-region-description"
            values={{ emphasis: <strong>{t('setup-data-region-emphasis')}</strong> }}
          />
        </div>
      </div>

      <div className="btn-group">
        <button className="btn btn--secondary" onClick={onBack}>
          {t('setup-back')}
        </button>
        <button className="btn btn--primary" onClick={onNext}>
          {t('setup-next')}
        </button>
      </div>
    </div>
  );
}
